function createToReversed() {
  if (Array.prototype.toReversed) return Array.prototype.toReversed
  return function toReversed<T>(this: T[]): T[] {
    // eslint-disable-next-line unicorn/no-array-reverse
    return this.slice().reverse()
  }
}

const internalToReversed = createToReversed()

export function toReversed<T>(thisArg?: T[]): T[] {
  if (thisArg === undefined || thisArg === null) return []
  return internalToReversed.call(thisArg)
}
